import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, PropType, ref, watch } from "vue";
import { getComponentUiText } from "@/utils/utilities";
import BaseInput from "@/components/common/form/baseInput.vue";
import WYSiwygEditor from "@/components/common/wysiwygEditor.vue";
import store from "@/store";
import useVuelidate from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";


export default /*#__PURE__*/_defineComponent({
  __name: 'actionDetail',
  props: {
  action: {
    type: Object as PropType<{
      checklistGroupName: string;
      checklistGroupTemplateName: string;
      checklistGroupDescription: string;
    }>,
    required: false,
    default: () => ({}),
  },
  placeholderTitleInput: {
    type: String,
    required: false,
    default: null,
  },
},
  emits: ["update:data"],
  setup(__props, { expose: __expose, emit }) {

const props = __props;





const form = ref({
  title:
    props.action?.checklistGroupName ||
    props.action?.checklistGroupTemplateName ||
    "",
});
const description = ref(props.action?.checklistGroupDescription || "");

watch(
  () => props.action,
  () => {
    form.value.title =
      props.action?.checklistGroupName ||
      props.action?.checklistGroupTemplateName ||
      "";
    description.value = props.action?.checklistGroupDescription || "";
  },
);

onMounted(() => {
  parseDescription();
});

const parseDescription = () => {
  const checklistGroupDescription =
    props.action?.checklistGroupDescription || "";
  try {
    const descriptions = JSON.parse(checklistGroupDescription);
    if (descriptions?.image) {
      const startChar = descriptions?.image.slice(0, 2);
    }
    description.value = descriptions?.description;
  } catch (e) {
    description.value = checklistGroupDescription;
  }
};

watch(
  [form.value, description],
  (value) => {
    store.commit("Recommend/SET_DATA_ACTION", {
      name: value[0].title,
      description: value[1],
    });
  },
  { deep: true },
);

watch(form.value, () => {
  store.commit("Recommend/SET_IS_CHANGE_TITLE_ACTION");
});

watch(description, () => {
  store.commit("Recommend/SET_IS_CHANGE_DESCRIPTION_ACTION");
});

const rules = {
  title: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
  },
};

const handleChangeDescription = (value) => {
  description.value = value;
  emit("update:data", { checklistGroupDescription: value });
};

let v$ = useVuelidate(rules, form);

const saveChanges = async () => {
  await v$.value.$validate();
  // true is not error
  return v$.value.$error;
};
__expose({
  saveChanges,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BaseInput, {
      id: "recommendationEditActionTitleField",
      modelValue: form.value.title,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((form.value.title) = $event)),
        _cache[1] || (_cache[1] = 
      (value) => _ctx.$emit('update:data', { checklistGroupName: value })
    )
      ],
      "data-cy-id": "action-detail-title",
      "class-name": `base-input-custom-modal-edit-action`,
      "input-class": "!tw-h-[56px]",
      placeholder: 
      __props.placeholderTitleInput ??
      _unref(getComponentUiText)(
        'app-assess-recommendations-edit-action-modal-action-detail-placeholder-1',
      )
    ,
      validation: _unref(v$).title,
      "validate-on-blur": true,
      label: 
      _unref(getComponentUiText)(
        'app-assess-recommendations-edit-action-modal-action-detail-title-1',
      )
    
    }, null, 8, ["modelValue", "placeholder", "validation", "label"]),
    _createVNode(BaseInput, {
      id: "recommendationEditActionDescriptionField",
      modelValue: description.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((description).value = $event)),
      "class-name": `base-input-custom-modal-edit-action !tw-items-start`,
      placeholder: 
      _unref(getComponentUiText)(
        'app-assess-recommendations-edit-action-modal-action-detail-placeholder-1',
      )
    ,
      label: 
      _unref(getComponentUiText)(
        'app-assess-recommendations-edit-action-modal-action-detail-description-1',
      )
    
    }, {
      default: _withCtx(() => [
        _createVNode(WYSiwygEditor, {
          modelValue: description.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((description).value = $event)),
          "data-cy-id": "action-detail-description",
          "include-image": false,
          "onUpdate:value": handleChangeDescription
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue", "placeholder", "label"])
  ], 64))
}
}

})